var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dropdown',{ref:"dropdown",style:(_vm.style),attrs:{"trigger":"click","placement":"bottom-start","transfer":false},on:{"on-click":_vm.click,"on-visible-change":_vm.onVisibleChange}},[_c('DropdownMenu',{attrs:{"slot":"list"},slot:"list"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }